import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private userPermissions: string[] = [];

  setPermissions(perms: string[]) {
    this.userPermissions = perms;
  }
   getPermissions(): string[] | null {
    return this.userPermissions;
  }

  hasAny(required: string[]): boolean {
    return required.some(p => this.userPermissions.includes(p));
  }

  hasAtLeastOnePermission(): boolean {
    return this.userPermissions.length > 0;
  }
}
